import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Drawer from "@material-ui/core/Drawer";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import Home from "@material-ui/icons/Home";
import Apps from "@material-ui/icons/Apps";
import ContactMail from "@material-ui/icons/ContactMail";
import { makeStyles } from "@material-ui/core/styles";
import avatar from "../avatar2.svg";
import MenuIcon from '@material-ui/icons/Menu';
import { useHistory, useLocation } from 'react-router-dom'
import Footer from "../components/Footer";

const useStyles = makeStyles((theme) => ({
  appbar: {
    background: "#0D1117",
    margin: 0,
  },
  
  menu: {
    color: "#F0F6FC",
    marginRight: 'auto',
  },
  title: {
    color: "#F0F6FC",
  },
  menuSliderContainer: {
    width: 250,
    background: "#161B22",
    height: "100%",
  },
  avatar: {
    display: "block",
    margin: "0.5rem auto",
    width: theme.spacing(13),
    height: theme.spacing(13),
  },
  listItem: {
    color: "#F0F6FC",
  },
}));

const menuItems = [
  { listIcon: <Home />, listText: "Home", listPath: "/" },
  { listIcon: <AssignmentInd />, listText: "Skills", listPath: "/skills" },
  { listIcon: <Apps />, listText: "Projects", listPath: "/project" },
  { listIcon: <ContactMail />, listText: "Contact", listPath: "/contact" },
];

const Navbar = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const history = useHistory()
  const location= useLocation()


  useEffect(() => {
    return history.listen(location => {

      if (history.action === 'POP') {
        if (open){
          setOpen(false)
        }
      }

    })
  }, [ history,open ])
  
  const sideList = () => (
    <Box className={classes.menuSliderContainer} component="div">
      <Avatar variant="square" className={classes.avatar} src={avatar} alt="Asad Jakahvala" />
      <Grid container justify="center">
        <Typography className={classes.title}>
                  asadjakhavala92@gmail.com
        </Typography>
        <Typography className={classes.title}>
                  +91 9512767792
        </Typography>
      </Grid>
      <Divider />
      <List>
        {menuItems.map((item, i) => (
          <ListItem
            button
            key={i}
            className={classes.listItem}
            onClick={() => setOpen(false) }
            component={Link}
            to={item.listPath}
          >
            <ListItemIcon className={classes.listItem}>
              {item.listIcon}
            </ListItemIcon>
            <ListItemText primary={item.listText} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <React.Fragment>
      <Box component="nav">
        <AppBar position="static" className={classes.appbar}>
          <Toolbar>
            <Box display='flex' flexGrow={1}>
            <Typography variant="h5" className={classes.title}>
                <code>{`<Asad Jakhavala/>`}</code>
            </Typography>
            </Box>
            <IconButton onClick={() => { setOpen(true); history.push(location.pathname); }}>
                <MenuIcon fontSize="large" className={classes.menu} />
              </IconButton>
          </Toolbar>
        </AppBar>
      </Box>
      <Drawer open={open} anchor="right" onClose={() => setOpen(false)}>
        {sideList()}
        <Footer />
      </Drawer>
    </React.Fragment>
  );
};

export default Navbar;
